<template>
    <div class="flex items-baseline">
        <span class="setting-header">Onboarding</span>
        <span class="ml-2">{{ selectedOrg?.organizationName }}</span>
        <div class="grow"/>
        <UButton v-if="canInitiateOnboarding" label="Initier onboarding" @click="initiateOnboarding"/>
        <UButton
            variant="ghost"
            size="sm"
            icon="i-ph-arrows-clockwise"
            title="Hent onboarding"
            @click="checkExistingOnboarding"
        />
    </div>
    <div class="py-2">
        <table v-if="onboarding" class="w-full setting-group">
            <thead>
                <tr>
                    <th>Leverandør</th>
                    <th>Status</th>
                    <th>Fullført</th>
                    <th>Valg</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ onboarding.origin }}</td>
                    <td class="flex gap-2">
                        <span>{{ onboarding.onboardingStatus }}</span>
                        <span v-if="onboarding.providerOnboardingStatus">({{ onboarding.providerOnboardingStatus }})</span>
                    </td>
                    <td>{{ formattedDate(onboarding.completedAt) }}</td>
                    <td>
                        <div class="flex items-center gap-2">
                            <UButton
                                v-if="isProcessing && onboarding.providerOnboardingUrl"
                                :to="onboarding?.providerOnboardingUrl"
                                variant="link"
                                color="primary"
                                size="sm"
                                label="Fullfør onboarding"
                                icon="i-ph-arrow-square-out"
                            />
                            <UButton
                                v-if="isProcessing"
                                variant="ghost"
                                size="sm"
                                icon="i-ph-arrows-clockwise"
                                title="Oppdater"
                                @click="checkOnboardingStatus"
                            />
                            <UButton
                                v-if="isCancellable"
                                variant="ghost"
                                size="sm"
                                color="error"
                                icon="i-ph-x-circle"
                                title="Avbryt"
                                @click="cancelOnboarding"
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="flex items-center setting-group py-2">
            Det er ingen onboarding enda.
        </div>
    </div>
</template>

<script setup lang="ts">
import {useRouter} from 'vue-router'
import {useOnboarding} from '@/bank/onboarding/onboarding.service'
import {onMounted} from 'vue'
import {formattedDate} from '@/services/formatter.service'
import {Tenant} from '@/tenants/Tenant'

const {onboarding, initiateOnboarding, checkOnboardingStatus, checkExistingOnboarding, isCancellable, cancelOnboarding, isProcessing, canInitiateOnboarding} = useOnboarding()
const router = useRouter()

defineProps({
    selectedOrg: {
        type: Object as () => Tenant | null,
        required: true
    }
})

onMounted(async () => {
    const {onboardingUuid, ...newQuery} = router.currentRoute.value.query
    if (onboardingUuid) {
        await router.replace({query: newQuery})
    }
})
</script>

<style scoped>
@reference "tailwindcss";

table {
    th {
        @apply px-4;
    }

    td {
        @apply px-4;
    }

    tr {
        @apply border-b dark:border-gray-400/30 text-left;
    }
}
</style>